import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import LoadingIcon from '../../components/shared/LoadingIcon';
import PatientInfo from '../../components/patient/PatientInfo';
import PatientAPIConnectors from '../../api/PatientAPIConnectors';

export class ReferPatientContainer extends Component {
  componentDidMount = async () => {
    const {
      actions: {
        fetchPatientDetail,
        createDangerAlert,
      },
      id,
    } = this.props;
    const result = await fetchPatientDetail(id);
    if (result !== true) {
      createDangerAlert(result.message);
    }
  }

  onRefer = () => {
    const doctorEmail = this.emailInput.value;
    PatientAPIConnectors.referPatient(this.props.id, doctorEmail)
      .then(() => {
        this.props.actions.createSuccessAlert(i18n.t('sharedWithDoctorSucceedMsg', { doctorEmail }));
        this.emailInput.value = '';
      })
      .catch((err) => {
        this.props.actions.createAlert({
          ...err,
          message: i18n.t('sharedPatientFailedMsg', { errMsg: err.message }),
        });
      })
      .then(() => {
        this.props.router.navigate('/medical-records', { trigger: true });
      });
  };

  render() {
    const patientInfo = this.props.patient.isPatientDetailLoading
      ? <LoadingIcon />
      : <PatientInfo {...this.props} />;

    return (
      <div className="ReferPatientContainer">
        <h1>
          {i18n.t('referPatient')}
        </h1>
        <p className="lead">
          {i18n.t('plzConfirmPatientMsg')}
        </p>
        <hr />
        <div className="input-group">
          <input
            className="form-control"
            type="text"
            ref={(input) => { this.emailInput = input; }}
            placeholder={i18n.t('doctorEmail')}
          />
          <span className="input-group-btn">
            <button className="btn btn-info" onClick={this.onRefer}>
              <i className="glyphicon glyphicon-share" />
              {i18n.t('refer')}
            </button>
          </span>
        </div>
        <hr />
        <div className="patient-info text-center">
          {patientInfo}
        </div>
      </div>
    );
  }
}

ReferPatientContainer.propTypes = {
  id: PropTypes.number.isRequired, // patient id
  actions: PropTypes.shape({
    fetchPatientDetail: PropTypes.func.isRequired,
    createDangerAlert: PropTypes.func.isRequired,
    createSuccessAlert: PropTypes.func.isRequired,
  }).isRequired,
  router: PropTypes.object.isRequired,
  patient: PropTypes.shape({
    isPatientDetailLoading: PropTypes.bool.isRequired,
  }).isRequired,
};

export default connectActionsAndReducers(ReferPatientContainer);



// WEBPACK FOOTER //
// ./src/containers/patient/ReferPatientContainer.js